<template>
  <baseFrame
    :infosArr="infosArr"
    :subInfosArr="subInfosArr"
    :id="id"
    :idText="idText"
  >
    <div slot="content">
      <lk-card title="付款单信息" class="mb16">
        <lk-form
          label-position='right'
          :labelWidth='120'>
          <lk-row>
            <!-- <lk-col span='10'>
			  <lk-form-item label='发票编码:'>
				<span>{{info.invoiceCode}}</span>
			  </lk-form-item>
			</lk-col>
			<lk-col span='10' offset='2'>
			  <lk-form-item label='发票日期:'>
				<span>{{info.invoiceDate|formatDate}}</span>
			  </lk-form-item>
			</lk-col> -->
            <lk-col span='10'>
              <lk-form-item label='发票总金额:'>
                <span>{{info.financePayment.invoiceAmount}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='10' offset='2'>
              <lk-form-item label='发票总税额:'>
                <span>{{info.financePayment.invoiceTotalTax}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='10'>
              <lk-form-item label='总金额:'>
                <span>{{info.financePayment.amountDisplay}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='10' offset='2'>
              <lk-form-item label='总税额:'>
                <span>{{info.financePayment.totalTaxDisplay}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='22'>
              <lk-form-item label='付款明细:'>
                <lk-table :columns='payableColumns' :data='payableList' border></lk-table>
              </lk-form-item>
            </lk-col>
            <lk-col span='22'>
              <lk-form-item label='备注:'>
                <span>{{info.financePayment.comment}}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
        </lk-form>
      </lk-card>
      <lk-card title="付款记录" class="mb16">
        <lk-form
          :label-width="134"
          label-position="right"
        >
          <lk-row>
            <!--<lk-col span="10">-->
              <!--<lk-form-item label="已支付金额:">-->
                <!--<span>{{info.paidAmount || 0}}</span>-->
              <!--</lk-form-item>-->
            <!--</lk-col>-->
            <lk-col span="23">
              <lk-form-item label="付款记录:">
                <lk-table :columns="paidColumns" :data="paidList" border></lk-table>
              </lk-form-item>
            </lk-col>
          </lk-row>
        </lk-form>
      </lk-card>
      <lk-card title="上下查询单据">
        <charts :type="6" :id='this.$route.params.id+""' @handleClick='getChartInfo'></charts>
        <div class="tabs">
          <lk-tabs type='card' v-model="currentTab">
            <lk-tab-pane label="当前单据" v-if="currentSheet.length" name='0'>
              <chartTable :data='currentSheet' :type='currentType'></chartTable>
            </lk-tab-pane>
            <lk-tab-pane label="上查单据" v-if="lastSheet.length" name='1'>
              <chartTable :data='lastSheet' :type='lastType'></chartTable>
              <chartTable v-if="hasDoubleLast" :data='lastSheet2' :type='lastType2'></chartTable>
            </lk-tab-pane>
            <lk-tab-pane label="下查单据" v-if="nextSheet.length" name='2'>
              <chartTable :data='nextSheet' :type='nextType' class="mb16"></chartTable>
              <chartTable v-if="hasDoubleNext" :data='nextSheet2' :type='nextType2'></chartTable>
            </lk-tab-pane>
          </lk-tabs>
        </div>
      </lk-card>
    </div>
  </baseFrame>
</template>
<script>
import baseFrame from '../../components/frame/BaseFrame.vue';
import charts from '../../components/charts.vue';
import chartTable from '../../components/chartTable.vue';
import finance from '../../services/finance';
import refund from '../../services/refund';
import utils from '../../libs/utils';

export default {
  name: 'payableInfoCheck',
  components: { baseFrame, charts, chartTable },
  data() {
    return {
      currentTab: 0,
      infosArr: [],
      subInfosArr: [],
      id: '',
      idText: '付款单号',
      currentSheet: [],
      lastSheet: [],
      lastSheet2: [],
      hasDoubleNext: false,
      hasDoubleLast: false,
      nextSheet: [],
      nextSheet2: [],
      currentType: 0,
      lastType: 0,
      lastType2: 0,
      nextType: 0,
      nextType2: 0,
      chartParams: {
        sourceType: 6, // 1采购计划 2采购订单 3收货单 4验收单 5应付单 6付款单 7退货单 8召回单
        sourceId: this.$route.params.id, // 付款单号
      },
      payableColumns: [
        { title: '序号', type: 'index', minWidth: 116 },
        {
          type: 'expand',
          width: 50,
          render: (h, params) => h('lk-table', {
            props: {
              columns: this.subColumns,
              data: params.row.subList,
            },
          }),
        },
        { title: '应付单号', key: 'code', minWidth: 116 },
        { title: '发票编码', key: 'invoiceCode', minWidth: 116 },
        { title: '发票时间', key: 'invoiceDate', minWidth: 116 },
        { title: '发票总金额', key: 'invoiceAmount', minWidth: 116 },
        { title: '发票总税额', key: 'invoiceTotalTax', minWidth: 116 },
      ],
      subColumns: [
        { title: '来源单据', key: 'referCode', minWidth: 116 },
        { title: '商品通用名', key: 'approvedDrugName', minWidth: 116 },
        { title: '规格', key: 'specification', minWidth: 116 },
        // { title: '生产企业', key: 'manufacturer', minWidth: 116 },
        { title: '确认单价', key: 'realPriceWithTax', minWidth: 116 },
        { title: '数量', key: 'num', minWidth: 116 },
        { title: '确认税率', key: 'realInputTaxRate', minWidth: 116 },
        { title: '不含税单价', key: 'realPriceAfterTax', minWidth: 116 },
        { title: '单个税额', key: 'realTax', minWidth: 116 },
        { title: '含税总金额', key: 'realTotalPriceBeforeTax', minWidth: 116 },
        { title: '总税额', key: 'realTotalTax', minWidth: 116 },
      ],
      payableList: [],
      info: {
        financePayment: {
          invoiceCode: '',
          invoiceDate: '',
          supplierId: '',
          comment: '',
        },
        purchaseMedicineInfoVoList: [],
      },
      paidList: [],
      paidColumns: [
        {
          title: '序号',
          type: 'index',
          minWidth: 110,
        },
        { title: '创建时间', key: 'createTime', minWidth: 116 },
        {
          title: '金额',
          key: 'amount',
          minWidth: 116,
        },
        {
          title: '类型',
          key: 'payWay',
          minWidth: 116,
          render: (h, { row }) => h('span', this.payWayMap.get(row.payWay)),
        },
        {
          title: '状态',
          key: 'statusName',
          minWidth: 116,
        },
        {
          title: '备注',
          key: 'remark',
          minWidth: 116,
        },
      ],
    };
  },
  computed: {
    payWayMap() {
      return this.$store.state.publicParams.payWayMap;
    },
  },
  methods: {
    getChartInfo(val) {
      switch (val.data.type) {
        case 1:
          this.getPurchasePlan(val.data.value);
          break;
        case 2:
          this.getPurchaseOrder(val.data.value);
          break;
        case 3:
          this.getPurchaseReceipt(val.data.value);
          break;
        case 4:
          this.getInspection(val.data.value);
          break;
        case 5:
          this.getPayable(val.data.value);
          break;
        case 6:
          this.getPayment(val.data.value);
          break;
        case 7:
          this.getRefund(val.data.value);
          break;
        case 8:
          this.getRecall(val.data.value);
          break;
        default:
          break;
      }
    },
    formatNode(data) {
      this.currentSheet = [];
      this.lastSheet = [];
      this.lastSheet2 = [];
      this.nextSheet = [];
      this.nextSheet2 = [];
      const {
        nextNode, nextNode2, lastNode, lastNode2, currentNode,
      } = data;
      if (nextNode) {
        this.nextType = nextNode.dataType;


        let tempNext = [];
        for (const key in nextNode) {
          if (key !== 'dataType') {
            if (Object.prototype.toString.call(nextNode[key]) === '[object Object]') {
              tempNext.push(nextNode[key]);
            } else {
              tempNext = tempNext.concat(nextNode[key]);
            }
          }
        }
        tempNext.forEach((item) => {
          let result = {};
          for (const key in item) {
            if (key !== 'dataType') {
              if (Object.prototype.toString.call(item[key]) === '[object Object]') {
                result = utils.deepClone(item[key]);
              } else if (Object.prototype.toString.call(item[key]) === '[object Array]' && item[key].length) {
                if (item[key].length > 0 && item[key][0].isFromSourceItem) {
                  result.subList = [];
                  item[key].forEach((el) => {
                    const tempItem = {};
                    utils.exchangeTable(el, tempItem);
                    result.subList.push(tempItem);
                  });
                }
              }
            }
          }
          this.nextSheet.push(result);
        });
      }
      if (nextNode2) {
        this.hasDoubleNext = true;
        this.nextType2 = nextNode2.dataType;
        let tempNext = [];
        for (const key in nextNode2) {
          if (key !== 'dataType') {
            if (Object.prototype.toString.call(nextNode2[key]) === '[object Object]') {
              tempNext.push(nextNode2[key]);
            } else {
              tempNext = tempNext.concat(nextNode2[key]);
            }
          }
        }
        tempNext.forEach((item) => {
          let result = {};
          for (const key in item) {
            if (key !== 'dataType') {
              if (Object.prototype.toString.call(item[key]) === '[object Object]') {
                result = utils.deepClone(item[key]);
              } else if (Object.prototype.toString.call(item[key]) === '[object Array]' && item[key].length) {
                if (item[key].length > 0 && item[key][0].isFromSourceItem) {
                  result.subList = [];
                  item[key].forEach((el) => {
                    const tempItem = {};
                    utils.exchangeTable(el, tempItem);
                    result.subList.push(tempItem);
                  });
                }
              }
            }
          }
          this.nextSheet2.push(result);
        });
      } else {
        this.hasDoubleNext = false;
      }
      if (lastNode) {
        this.lastType = lastNode.dataType;
        let tempLast = [];
        for (const key in lastNode) {
          if (key !== 'dataType') {
            if (Object.prototype.toString.call(lastNode[key]) === '[object Object]') {
              tempLast.push(lastNode[key]);
            } else {
              tempLast = tempLast.concat(lastNode[key]);
            }
          }
        }

        tempLast.forEach((item) => {
          let result = {};
          for (const key in item) {
            if (Object.prototype.toString.call(item[key]) === '[object Object]') {
              result = utils.deepClone(item[key]);
            } else if (Object.prototype.toString.call(item[key]) === '[object Array]' && item[key].length) {
              if (item[key].length > 0 && item[key][0].isFromSourceItem) {
                result.subList = [];
                item[key].forEach((el) => {
                  const tempItem = {};
                  utils.exchangeTable(el, tempItem);
                  result.subList.push(tempItem);
                });
              }
            }
          }
          this.lastSheet.push(result);
        });
      }
      if (lastNode2) {
        this.hasDoubleLast = true;
        this.lastType2 = lastNode2.dataType;
        let tempLast = [];
        for (const key in lastNode2) {
          if (key !== 'dataType') {
            if (Object.prototype.toString.call(lastNode2[key]) === '[object Object]') {
              tempLast.push(lastNode2[key]);
            } else {
              tempLast = tempLast.concat(lastNode2[key]);
            }
          }
        }
        tempLast.forEach((item) => {
          let result = {};
          for (const key in item) {
            if (Object.prototype.toString.call(item[key]) === '[object Object]') {
              result = utils.deepClone(item[key]);
            } else if (Object.prototype.toString.call(item[key]) === '[object Array]' && item[key].length) {
              if (item[key].length > 0 && item[key][0].isFromSourceItem) {
                result.subList = [];
                item[key].forEach((el) => {
                  const tempItem = {};
                  utils.exchangeTable(el, tempItem);
                  result.subList.push(tempItem);
                });
              }
            }
          }
          this.lastSheet2.push(result);
        });
      } else {
        this.hasDoubleLast = false;
      }
      if (currentNode) {
        this.currentType = currentNode.dataType;
        let tempCurrent = [];
        for (const key in currentNode) {
          if (key !== 'dataType') {
            if (Object.prototype.toString.call(currentNode[key]) === '[object Object]') {
              tempCurrent.push(currentNode[key]);
            } else {
              tempCurrent = tempCurrent.concat(currentNode[key]);
            }
          }
        }

        tempCurrent.forEach((item) => {
          let result = {};
          for (const key in item) {
            if (key !== 'dataType') {
              if (Object.prototype.toString.call(item[key]) === '[object Object]') {
                result = utils.deepClone(item[key]);
              } else if (Object.prototype.toString.call(item[key]) === '[object Array]') {
                if (item[key].length > 0 && item[key][0].isFromSourceItem) {
                  result.subList = [];
                  item[key].forEach((el) => {
                    const tempItem = {};
                    utils.exchangeTable(el, tempItem);
                    result.subList.push(tempItem);
                  });
                }
              }
            }
          }
          this.currentSheet.push(result);
        });
      }
    },
    getPayable(id) {
      const params = utils.deepClone(this.chartParams);
      params.financePayableId = id;
      finance.flowInfoPayable(params).then((res) => {
        if (res.data.status === 200) {
          this.formatNode(res.data.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getRecall(id) {
      const params = utils.deepClone(this.chartParams);
      params.recallPlanId = id;
      finance.getInfoAroundRecallPlan(params).then((res) => {
        if (res.data.status === 200) {
          this.formatNode(res.data.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getPayment(id) {
      const params = utils.deepClone(this.chartParams);
      params.financePaymentId = id;
      finance.flowInfoPayment(params).then((res) => {
        if (res.data.status === 200) {
          this.formatNode(res.data.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getRefund(id) {
      const params = utils.deepClone(this.chartParams);
      params.purchaseRefundId = id;
      refund.purchaseRefundChartLinkInfo(params).then((res) => {
        if (res.data.status === 200) {
          this.formatNode(res.data.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getInspection(id) {
      const params = utils.deepClone(this.chartParams);
      params.purchaseInspectionId = id;
      finance.flowInfoInspection(params).then((res) => {
        if (res.data.status === 200) {
          this.formatNode(res.data.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getPurchaseReceipt(id) {
      const params = utils.deepClone(this.chartParams);
      params.purchaseReceiptId = id;
      finance.flowInfoPurchaseReceipt(params).then((res) => {
        if (res.data.status === 200) {
          this.formatNode(res.data.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getPurchaseOrder(id) {
      const params = utils.deepClone(this.chartParams);
      params.purchaseOrderId = id;
      finance.flowInfoPurchaseOrder(params).then((res) => {
        if (res.data.status === 200) {
          this.formatNode(res.data.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getPurchasePlan(id) {
      const params = utils.deepClone(this.chartParams);
      params.purchasePlanId = id;
      finance.flowInfoPurchasePlan(params).then((res) => {
        if (res.data.status === 200) {
          this.formatNode(res.data.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getDetails() {
      finance.getFinancePaymentDetail({ financePaymentId: `${this.$route.params.id}` }).then((res) => {
        if (res.data.status === 200) {
          const temp = res.data.data;
          temp.financePayment.invoiceDate = new Date(temp.financePayment.invoiceDate);
          temp.financePayableVoList.forEach((item) => {
            item.financePayable.subList = [];
            item.financePayableInfoList.forEach((el) => {
              const result = {};
              utils.exchangeTable(el, result);
              result.realInputTaxRate += '%';
              item.financePayable.subList.push(result);
            });
            const listItem = utils.deepClone(item.financePayable);
            listItem.invoiceDate = utils.exchangeTime(listItem.invoiceDate);
            this.payableList.push(listItem);
          });

          temp.financePaymentRecordList.forEach((item) => {
            item.createTime = utils.formatDate(item.createTime);
            this.paidList.push(item);
          });

          this.info = utils.deepClone(temp);
          this.id = this.info.financePayment.code;
          this.infosArr[0] = {
            name: '门店名称:',
            value: this.info.financePayment.storeName,
          };
          this.infosArr[1] = {
            name: '供应商:',
            value: this.info.financePayment.supplierName,
          };
          this.infosArr[2] = {
            name: '创建人:',
            value: this.info.financePayment.createUserName,
          };
          this.infosArr[3] = {
            name: '创建时间:',
            value: utils.exchangeTimeToSecond(this.info.financePayment.createTime),
          };
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    this.getDetails();
    this.getChartInfo({ data: { type: 6, value: this.$route.params.id } });
  },
};
</script>
<style lang="less" scoped>

</style>
